import { render, staticRenderFns } from "./OnInspectC5.vue?vue&type=template&id=3445c796&"
import script from "./OnInspectC5.vue?vue&type=script&lang=js&"
export * from "./OnInspectC5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports